import React from "react";
import TestingConfigPanel from "../components/testing/TestingConfigPanel";
import { toast } from "react-hot-toast";

const STORAGE_KEY = "globalTestingConfig";

const SettingsPage: React.FC = () => {
  const [conversationKey, setConversationKey] = React.useState<string>("");
  const [sessionId, setSessionId] = React.useState<string>("");
  const [saving, setSaving] = React.useState<boolean>(false);

  React.useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        const obj = JSON.parse(saved) || {};
        setConversationKey(obj.conversation_key || "");
        setSessionId(obj.session_id || "");
      }
    } catch {}
  }, []);

  const onSave = async () => {
    setSaving(true);
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          conversation_key: conversationKey || "",
          session_id: sessionId || "",
        }),
      );
      toast.success("Testing configuration saved");
    } catch {
      toast.error("Failed to save testing configuration");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
      <TestingConfigPanel
        title="Testing Configuration"
        conversationKey={conversationKey}
        setConversationKey={setConversationKey}
        sessionId={sessionId}
        setSessionId={setSessionId}
        onSave={onSave}
        saving={saving}
      />
    </div>
  );
};

export default SettingsPage;
